export const viewport = () => {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  return { width, height };
};

export const isScreen3kMin = () => {
  const { width, height } = viewport();

  return width >= 2880 && height >= 1620;
};

export const holdScrollPosition = (delay?: number) => {
  if (typeof window !== undefined) {
    window.holdScrollPosition = true;
    setTimeout(
      () => {
        window.holdScrollPosition = false;
      },
      delay ? delay : 2000,
    );
  }
};

interface IUrlParameters {
  devmode?: boolean;
  purpose?: string;
  page?: string;
  source?: string;
  utm_source?: string;
}

export const searchToObject = () => {
  const pairs = window.location.search.substring(1).split('&');
  const obj: IUrlParameters = {};

  for (const pair of pairs) {
    if (pair === '') {
      continue;
    }

    const [key, value] = pair.split('=');
    const decodedKey = decodeURIComponent(key);
    const decodedValue = value ? decodeURIComponent(value) : true;

    if (decodedValue === 'true') {
      obj[decodedKey] = true;
    } else if (decodedValue === 'false') {
      obj[decodedKey] = false;
    } else {
      obj[decodedKey] = decodedValue;
    }
  }

  return obj;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const arrayToObjectByKey = <T extends Record<string, any>, K extends keyof T>(
  array: T[],
  key: K,
): Record<T[K], T> => {
  return array.reduce(
    (acc, obj) => {
      const keyValue = obj[key];
      acc[keyValue] = obj;
      return acc;
    },
    {} as Record<T[K], T>,
  );
};
